import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDevices2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconDevices2"><Path d="M21 9C22.1046 9 23 9.89543 23 11V19C23 20.1046 22.1046 21 21 21H18C16.8954 21 16 20.1046 16 19V11C16 9.89543 16.8954 9 18 9H21Z" fill="currentColor"/><Path d="M15 20H3C1.89543 20 1 19.1046 1 18V17.5C1 17.2239 1.22386 17 1.5 17H15V20Z" fill="currentColor"/><Path d="M18.5 3C19.8807 3 21 4.11929 21 5.5V8H18C16.3431 8 15 9.34315 15 11V16H3V5.5C3 4.11929 4.11929 3 5.5 3H18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDevices2;
